import { render, staticRenderFns } from "./IntegrationPartnerCallRail.vue?vue&type=template&id=118d222c&scoped=true&"
import script from "./IntegrationPartnerCallRail.vue?vue&type=script&lang=js&"
export * from "./IntegrationPartnerCallRail.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationPartnerCallRail.vue?vue&type=style&index=0&id=118d222c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d222c",
  null
  
)

export default component.exports